import ButtonFile from "#common/buttons/ButtonFile"
import { useApiSend } from "#hooks/useApiSend"
import { salariesPost } from "#salaries/services/Api"
import { Button } from "@mui/material"
import { Typography } from "@mui/material"
import Box from "@mui/material/Box"
import { ChangeTitle } from "Components/menu/funciones"
import { useState } from "react"
import Table from "./Table"

const Index = () => {
	ChangeTitle("Recibos de nomina")

	return (
		<Box display="flex" width="100%" flexDirection="column" gap={2}>
			<UploadSalaries />
		</Box>
	)
}

export default Index
const UploadSalaries = () => {
	const [excel, setExcel] = useState(null)
	const { fetch } = useApiSend(salariesPost, {})

	return (
		<Box display="flex" width="100%" flexDirection="column" gap={2}>
			{/* <div style={{ flex: 1 }}>
				<Typography variant="h6">Subir pagos de salarios</Typography>
			</div>
			<div style={{ flex: 3.2, height: "87vh" }}>
				<ButtonFile
					label="Subir pagos de salarios"
					icon="upload"
					getFiles={(files) => setExcel(files[0])}
				/>
			</div>
			<div style={{ flex: 3.2, height: "87vh" }}>
				<Button
					label="Enviar"
					icon="upload"
					onClick={() => {
						const formData = new FormData()
						formData.append("sociedad_id", 9)
						formData.append("excel", excel)
						fetch(formData)
					}}
				>
					enviar
				</Button>
			</div> */}
			<div style={{ flex: 3.2, height: "87vh" }}>
				<Table />
			</div>
		</Box>
	)
}
